import { render, staticRenderFns } from "./ProductObjects.vue?vue&type=template&id=77985f00&"
import script from "./ProductObjects.vue?vue&type=script&lang=js&"
export * from "./ProductObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports